// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RmlD-","content":"styles_content__t_d95","tableWrap":"styles_tableWrap__3H_s1"};